import { USER_ACTIVITY } from '../types';

const initialState = {
  isActive: true,
};

const userActivityReducer = (state = initialState, action) => {
  switch (action.type) {
  case USER_ACTIVITY:
    return {
      isActive: action.isActive,
    };
  default:
    return state;
  }
};

export default userActivityReducer;
